import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import CollectionSyncMixin from './CollectionSyncMixin';
import DurationTerminal from './terminals/Duration';
import PhoneTypeTerminal from './terminals/PhoneType';
import AgeTerminal from './terminals/Age';
import VoiceTerminal from './terminals/Voice';
import StringCompareTerminal from './terminals/StringCompare';
import NumberCompareTerminal from './terminals/NumberCompare';
import MoneyCompareTerminal from './terminals/MoneyCompare';
import PoolParamTerminal from './terminals/PoolParam';
import CustomDataTerminal from './terminals/CustomData';
import ScorecardTerminal from './terminals/Scorecard';
import AdwordsDataTerminal from './terminals/AdwordsData';
import StringListTerminal from './terminals/StringListTerminal';
import BooleanTerminal from './terminals/BooleanTerminal';
import ConjunctionTerminal from './terminals/Conjunction';
import ParenTerminal from './terminals/Paren';
import NotTerminal from './terminals/Not';
import UnsupportedTerminal from './terminals/Unsupported';
import KeypressTerminal from './terminals/Keypress';

import ExceptionHandling from "shared/logging/exception_handling";

const Components = {
  DurationTerminal,
  PhoneTypeTerminal,
  AgeTerminal,
  VoiceTerminal,
  StringCompareTerminal,
  NumberCompareTerminal,
  MoneyCompareTerminal,
  PoolParamTerminal,
  CustomDataTerminal,
  ScorecardTerminal,
  AdwordsDataTerminal,
  StringListTerminal,
  BooleanTerminal,
  ConjunctionTerminal,
  ParenTerminal,
  NotTerminal,
  UnsupportedTerminal,
  KeypressTerminal
};

const ExpressionCanvas = createReactClass({
  displayName: 'ExpressionCanvas',
  mixins: [CollectionSyncMixin],

  getBackboneCollections: function() {
    return [this.props.expressionTerminals];
  },

  propTypes: {
    expressionText: PropTypes.string,
    expressionTerminals: PropTypes.object.isRequired,
    terminalMetaData: PropTypes.object.isRequired,
    editable: PropTypes.bool
  },

  render: function() {
    var components = this.props.expressionTerminals.map(function(node, index) {
      return (
        <div className={classNames('expression', this._readOnlyClass())} key={node.get('terminal') + ":" + index}>
          {this._componentForTerminal(node)}
        </div>
      );
    }, this);

    return (
      <div className={classNames('expression-canvas', this._readOnlyClass())} style={{ backgroundImage: this.props.expressionTerminals.length > 0 ? 'none' : null }}>
        {components}
      </div>
    );
  },

  remove: function(node, event) {
    this.props.expressionTerminals.removeTerminal(node);
  },

  _componentForTerminal: function(node) {
    if (node.type() === 'Unsupported') {
      ExceptionHandling.logError("Unknown node terminal name: " + node.get('terminal'));
    }

    var ComponentClassName = Components[node.type() + 'Terminal'];
    return (
      <ComponentClassName
        node={node}
        remove={this.remove}
        selectUrls={this.props.selectUrls}
        selectValues={this.props.selectValues}
        editable={this.props.editable}
        metaData={this.props.terminalMetaData[node.attributes.terminal]}
      />
    );
  },

  _readOnlyClass: function() {
    return this.props.editable ? '' : 'readonly';
  }
});

export default ExpressionCanvas;
